// extracted by mini-css-extract-plugin
export default {"container":"p0-z","list":"q0-z"};